import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pagination" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pagination_bullet" }),
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Swiper"], _mergeProps({ id: "main-card-swiper" }, $setup.swiperOptions, { onSlideChange: $setup.onSlideChange }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.favoriteLines, (favoriteLine, index) => {
          return (_openBlock(), _createBlock($setup["SwiperSlide"], {
            key: index,
            class: "card-slide"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MainCard"], {
                ref_for: true,
                ref: "mainCard",
                favoriteLine: favoriteLine,
                shouldCurrentCardShowFront: $props.shouldCurrentCardShowFront,
                cardIndex: index,
                currentCardIndex: $setup.swiperRealIndex,
                onBoardLine: $props.onBoardLine,
                onOnClickLineInfo: ($event: any) => (_ctx.$emit('onClickLineInfo', favoriteLine)),
                onOnClickBusStopLocation: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $event))),
                onUpdateBusLocation: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateBusLocation'))),
                onOnChangedCheck: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onChangedCheck', $event))),
                onOnClickScheduleBtn: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onClickScheduleBtn', $event))),
                onOnClickReportBtn: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onClickReportBtn'))),
                onOnClickBusImage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('onClickBusImage')))
              }, null, 8 /* PROPS */, ["favoriteLine", "shouldCurrentCardShowFront", "cardIndex", "currentCardIndex", "onBoardLine", "onOnClickLineInfo"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */),
    _hoisted_1
  ], 64 /* STABLE_FRAGMENT */))
}